module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "hgroup"
  }, [_c('h3'), _vm._v(" "), _c('h1', [_vm._v("Copyright")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('br'), _vm._v("\n\tDiversion Books"), _c('br'), _vm._v("\n\tA Division of Diversion Publishing Corp."), _c('br'), _vm._v("\n\t443 Park Avenue South, Suite 1004"), _c('br'), _vm._v("\n\tNew York, New York 10016"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.diversionbooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("www.DiversionBooks.com")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v("\n\tCopyright © 2012 by The Washington Post")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n\tCover designed by David Griffin")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n\tCover image courtesy of HARRY NALTCHAYAN/TWP")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('br'), _vm._v("\n\tAll rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('br'), _vm._v("\n\tFor more information, email "), _c('a', {
    attrs: {
      "href": "mailto:info@diversionbooks.com"
    }
  }, [_vm._v("info@diversionbooks.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('br'), _vm._v("\n\tFirst Diversion Books edition September 2012.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n\tISBN: 978-1-938120-58-9 (ebook)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-460ef848","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap71682.vue
// module id = 63
// module chunks = 0